import { ChainId } from "src/constants"
import { getChainId } from "."

export const getAddress = (address: Record<ChainId, string>): string => {
  const chainId = getChainId()
  return address[chainId]
}
